<template>
  <div>
    <nav
    class="navbar navbar-expand-lg bg-nav navbar-light  mb-0 pb-0"
    >
      <div class="container">
        <router-link class="navbar-brand" to="/" @click.native="changePage(0)">
          <img src="../assets/logo.png" width="80" />
        </router-link>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbars1"
          aria-controls="navbars1"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbars1" v-if="this.$store.state.user">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link class="nav-link fw-semibold" aria-current="page" to="/" :class="{ active_button: isHome }" @click.native="changePage(0)">
              <svg class="mb-1" width="16" height="16" viewBox="0 0 16 16"  xmlns="http://www.w3.org/2000/svg" >
              <path d="M7.27148 15.958C5.22948 15.764 3.51082 14.9133 2.11548 13.406C0.719484 11.8993 0.0214844 10.0973 0.0214844 7.99999C0.0214844 5.90266 0.719484 4.10066 2.11548 2.59399C3.51082 1.08666 5.22948 0.235992 7.27148 0.0419922V2.04199C5.78548 2.23599 4.53882 2.89566 3.53148 4.02099C2.52482 5.14566 2.02148 6.47199 2.02148 7.99999C2.02148 9.52799 2.52482 10.8543 3.53148 11.979C4.53882 13.1043 5.78548 13.764 7.27148 13.958V15.958ZM8.77148 15.958V13.958C10.1322 13.7913 11.2988 13.222 12.2715 12.25C13.2435 11.278 13.8128 10.1113 13.9795 8.74999H15.9795C15.7988 10.6667 15.0315 12.302 13.6775 13.656C12.3235 15.0107 10.6882 15.778 8.77148 15.958ZM13.9795 7.24999C13.8128 5.88866 13.2435 4.72199 12.2715 3.74999C11.2988 2.77799 10.1322 2.20866 8.77148 2.04199V0.0419922C10.6882 0.221992 12.3235 0.989325 13.6775 2.34399C15.0315 3.69799 15.7988 5.33333 15.9795 7.24999H13.9795Z" v-bind:fill="[isHome ? '#4DA3F7':'#888']" />
              </svg>
               Masallar</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link fw-semibold" aria-current="page" to="/archive" :class="{ active_button: isArchive }" @click.native="changePage(1)">
              <svg class="mb-1" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" >
              <path d="M1 14.5V5.917C0.680667 5.81967 0.434 5.639 0.26 5.375C0.0866667 5.111 0 4.81933 0 4.5V1.5C0 1.08333 0.146 0.729333 0.438 0.438C0.729333 0.146 1.08333 0 1.5 0H14.5C14.9167 0 15.2707 0.146 15.562 0.438C15.854 0.729333 16 1.08333 16 1.5V4.5C16 4.81933 15.9133 5.111 15.74 5.375C15.566 5.639 15.3193 5.81967 15 5.917V14.5C15 14.9167 14.854 15.2707 14.562 15.562C14.2707 15.854 13.9167 16 13.5 16H2.5C2.08333 16 1.72933 15.854 1.438 15.562C1.146 15.2707 1 14.9167 1 14.5ZM2.5 6V14.5H13.5V6H2.5ZM14.5 4.5V1.5H1.5V4.5H14.5ZM6 9.5H10V8H6V9.5Z" v-bind:fill="[isArchive ? '#4DA3F7':'#888']" />
              </svg>
               Arşiv</router-link>
            </li>
          </ul>
          <ul class="navbar-nav mb-2 mb-lg-0">

            <li class="nav-item dropdown dropstart ">
              <a v-show='this.$route.name != "search"' @click="loadAll()"
                class="nav-link dropdown-toggle text-secondary fw-semibold"
                href="#"
                id="dropdownSearch"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="bi bi-search"></i> Arama</a
              >
              <ul class="dropdown-menu text-secondary" style="min-width:17rem;background-color:#f7f7f7;" aria-labelledby="dropdownSearch">
                <li class="p-3">
                  <span style="color:#22303F">ARAMA</span>
                  <div class="row mt-3">
                    <div class="col-4">
                      <input type="text" @keypress="onlyNumber($event)" class="form-control text-center" placeholder="ID" v-model="searchID.id"  />
                    </div>
                    <div class="col-6 d-grid">
                      <button class="btn btn-secondary text-white" @click="goTale(searchID)">GİT
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.43783 0.91668L12.9378 6.41668C13.0212 6.50001 13.0803 6.59029 13.1153 6.68751C13.1498 6.78474 13.167 6.8889 13.167 7.00001C13.167 7.11112 13.1498 7.21529 13.1153 7.31251C13.0803 7.40974 13.0212 7.50001 12.9378 7.58335L7.43783 13.0833C7.28505 13.2361 7.09421 13.3161 6.86533 13.3233C6.63588 13.33 6.43783 13.25 6.27116 13.0833C6.10449 12.9306 6.01755 12.7397 6.01033 12.5108C6.00366 12.2814 6.08366 12.0833 6.25033 11.9167L10.3337 7.83335L1.02116 7.83335C0.785048 7.83335 0.586992 7.75362 0.426992 7.59418C0.267548 7.43418 0.187825 7.23612 0.187825 7.00001C0.187825 6.7639 0.267548 6.56612 0.426992 6.40668C0.586992 6.24668 0.785048 6.16668 1.02116 6.16668L10.3337 6.16668L6.25033 2.08335C6.09755 1.93057 6.01755 1.73612 6.01033 1.50001C6.00366 1.2639 6.08366 1.06946 6.25033 0.91668C6.4031 0.750014 6.59755 0.666679 6.83366 0.666679C7.06977 0.666679 7.27116 0.750014 7.43783 0.91668Z" fill="white"/>
                        </svg>
                      </button>
                    </div>
                    <hr class="mt-2" />
                    <div class="col-12">
                      DURUM
                    </div>
                    <div class="col-12">
                      <select class="form-select" aria-label="Select status" aria-placeholder="Select Status" v-model="q.status">
                        <option value="" selected>Tümü</option>
                        <option value="request">Masal İstekleri</option>
                        <option value="complete">Yayınlanmış</option>
                      </select>
                    </div>
                    <hr class="mt-2" />
                    <div class="col-12">
                      Başlık
                    </div>
                    <div class="col-12">
                      <input type="text" class="form-control" placeholder="Başlık" v-model="q.title" />
                    </div>
                    <hr class="mt-2" />
                    <div class="col-12">
                      Kategori
                    </div>
                    <div class="col-12">
                      <select class="form-select" aria-label="Kategori Seç" aria-placeholder="Kategori Seç" v-model="q.category">
                                                <option value="" selected>Tümü</option>

                          <option v-for="(a,index) in catAll" :key="index" v-bind:value="a">{{a.name}}</option>
                      </select>
                    </div>
                    <hr class="mt-2" />
                    <div class="col-12">
                      Yaş
                    </div>
                    <div class="col-12">
                      <select class="form-select" aria-label="Select status" aria-placeholder="Select Status" v-model="q.age" >
                        <option value="" selected>Tümü</option>
                          <option v-for="(a,index) in ages" :key="index" v-bind:value="a">{{a.min_age}}+</option>
                      </select>
                    </div>
                    <div class="col-12 mt-3 mp-2 d-grid">
                    <button @click="goSearch()"
                      class="btn btn-primary text-white"
                      type="submit"
                    > ARA
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.43783 0.91668L12.9378 6.41668C13.0212 6.50001 13.0803 6.59029 13.1153 6.68751C13.1498 6.78474 13.167 6.8889 13.167 7.00001C13.167 7.11112 13.1498 7.21529 13.1153 7.31251C13.0803 7.40974 13.0212 7.50001 12.9378 7.58335L7.43783 13.0833C7.28505 13.2361 7.09421 13.3161 6.86533 13.3233C6.63588 13.33 6.43783 13.25 6.27116 13.0833C6.10449 12.9306 6.01755 12.7397 6.01033 12.5108C6.00366 12.2814 6.08366 12.0833 6.25033 11.9167L10.3337 7.83335L1.02116 7.83335C0.785048 7.83335 0.586992 7.75362 0.426992 7.59418C0.267548 7.43418 0.187825 7.23612 0.187825 7.00001C0.187825 6.7639 0.267548 6.56612 0.426992 6.40668C0.586992 6.24668 0.785048 6.16668 1.02116 6.16668L10.3337 6.16668L6.25033 2.08335C6.09755 1.93057 6.01755 1.73612 6.01033 1.50001C6.00366 1.2639 6.08366 1.06946 6.25033 0.91668C6.4031 0.750014 6.59755 0.666679 6.83366 0.666679C7.06977 0.666679 7.27116 0.750014 7.43783 0.91668Z" fill="white"/>
                        </svg>

                    </button>
                    </div>


                  </div>

                </li>
              </ul>
            </li>


            <li class="nav-item dropdown ">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="dropdownUser"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {{this.$store.state.user.first_name + " " + this.$store.state.user.last_name }}</a
              >
              <ul class="dropdown-menu" aria-labelledby="dropdownUser">
                <li>
                  <router-link class="dropdown-item" to="/settings">
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5835 17.333H7.41748C7.19481 17.333 7.00381 17.2603 6.84448 17.115C6.68448 16.969 6.59048 16.7847 6.56248 16.562L6.33348 14.708C6.19481 14.6247 6.04214 14.5347 5.87548 14.438C5.70881 14.3407 5.55614 14.2503 5.41748 14.167L3.68848 14.896C3.47981 14.9793 3.27114 14.9863 3.06248 14.917C2.85448 14.847 2.69481 14.715 2.58348 14.521L1.02148 11.792C0.910144 11.5973 0.878811 11.396 0.927478 11.188C0.976144 10.9793 1.08381 10.8057 1.25048 10.667L2.70848 9.54199V8.45799L1.25048 7.33299C1.08381 7.19433 0.976144 7.02066 0.927478 6.81199C0.878811 6.60399 0.910144 6.40266 1.02148 6.20799L2.58348 3.47899C2.69481 3.28499 2.85448 3.15299 3.06248 3.08299C3.27114 3.01366 3.47981 3.02066 3.68848 3.10399L5.41748 3.83299C5.55614 3.74966 5.70881 3.65966 5.87548 3.56299C6.04214 3.46566 6.19481 3.37533 6.33348 3.29199L6.56248 1.43799C6.59048 1.21533 6.68448 1.03099 6.84448 0.884992C7.00381 0.739659 7.19481 0.666992 7.41748 0.666992H10.5835C10.8061 0.666992 10.9971 0.739659 11.1565 0.884992C11.3165 1.03099 11.4105 1.21533 11.4385 1.43799L11.6675 3.29199C11.8061 3.37533 11.9588 3.46566 12.1255 3.56299C12.2921 3.65966 12.4448 3.74966 12.5835 3.83299L14.3125 3.10399C14.5211 3.02066 14.7298 3.01366 14.9385 3.08299C15.1465 3.15299 15.3061 3.28499 15.4175 3.47899L17.0005 6.20799C17.1118 6.40266 17.1465 6.60399 17.1045 6.81199C17.0631 7.02066 16.9521 7.19433 16.7715 7.33299L15.3125 8.45799V9.54199L16.7715 10.667C16.9521 10.8057 17.0631 10.9793 17.1045 11.188C17.1465 11.396 17.1118 11.5973 17.0005 11.792L15.4175 14.521C15.3061 14.715 15.1465 14.847 14.9385 14.917C14.7298 14.9863 14.5211 14.9793 14.3125 14.896L12.5835 14.167C12.4448 14.2503 12.2921 14.3407 12.1255 14.438C11.9588 14.5347 11.8061 14.6247 11.6675 14.708L11.4385 16.562C11.4105 16.7847 11.3165 16.969 11.1565 17.115C10.9971 17.2603 10.8061 17.333 10.5835 17.333ZM9.00048 11.979C9.81981 11.979 10.5211 11.6873 11.1045 11.104C11.6878 10.5207 11.9795 9.81933 11.9795 8.99999C11.9795 8.18066 11.6878 7.47933 11.1045 6.89599C10.5211 6.31266 9.81981 6.02099 9.00048 6.02099C8.18114 6.02099 7.47981 6.31266 6.89648 6.89599C6.31314 7.47933 6.02148 8.18066 6.02148 8.99999C6.02148 9.81933 6.31314 10.5207 6.89648 11.104C7.47981 11.6873 8.18114 11.979 9.00048 11.979ZM9.00048 10.229C8.66714 10.229 8.37881 10.1077 8.13548 9.86499C7.89281 9.62166 7.77148 9.33333 7.77148 8.99999C7.77148 8.66666 7.89281 8.37833 8.13548 8.13499C8.37881 7.89233 8.66714 7.77099 9.00048 7.77099C9.33381 7.77099 9.62214 7.89233 9.86548 8.13499C10.1081 8.37833 10.2295 8.66666 10.2295 8.99999C10.2295 9.33333 10.1081 9.62166 9.86548 9.86499C9.62214 10.1077 9.33381 10.229 9.00048 10.229ZM8.16748 15.583H9.83348L10.0835 13.417C10.4868 13.3057 10.8758 13.139 11.2505 12.917C11.6251 12.6943 11.9655 12.4303 12.2715 12.125L14.2925 12.979L15.1255 11.604L13.3545 10.25C13.4238 10.0553 13.4725 9.85399 13.5005 9.64599C13.5285 9.43733 13.5425 9.22199 13.5425 8.99999C13.5425 8.80533 13.5285 8.60733 13.5005 8.40599C13.4725 8.20466 13.4308 7.99299 13.3755 7.77099L15.1465 6.39599L14.3125 5.02099L12.2925 5.89599C11.9725 5.57666 11.6285 5.30933 11.2605 5.09399C10.8925 4.87866 10.5071 4.71533 10.1045 4.60399L9.83348 2.41699H8.16748L7.89648 4.60399C7.49381 4.71533 7.10848 4.87866 6.74048 5.09399C6.37248 5.30933 6.03548 5.56966 5.72948 5.87499L3.70848 5.02099L2.87548 6.39599L4.62548 7.74999C4.57014 7.97199 4.52848 8.18733 4.50048 8.39599C4.47248 8.60399 4.45848 8.80533 4.45848 8.99999C4.45848 9.19466 4.47248 9.39266 4.50048 9.59399C4.52848 9.79533 4.57014 10.007 4.62548 10.229L2.87548 11.604L3.70848 12.979L5.72948 12.125C6.03548 12.4303 6.37248 12.6907 6.74048 12.906C7.10848 13.1213 7.49381 13.2847 7.89648 13.396L8.16748 15.583Z" fill="#888"/>
</svg> Ayarlar</router-link>
                </li>
                <li>
                  <router-link class="dropdown-item" to="/logout">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.625 11.667C10.4583 11.5003 10.375 11.2953 10.375 11.052C10.375 10.8093 10.4583 10.6047 10.625 10.438L12.188 8.875H6.396C6.16 8.875 5.955 8.78833 5.781 8.615C5.60767 8.441 5.521 8.236 5.521 8C5.521 7.764 5.60767 7.559 5.781 7.385C5.955 7.21167 6.16 7.125 6.396 7.125H12.125L10.604 5.583C10.4513 5.41633 10.375 5.215 10.375 4.979C10.375 4.743 10.4583 4.54167 10.625 4.375C10.7917 4.20833 10.9967 4.125 11.24 4.125C11.4827 4.125 11.6873 4.20833 11.854 4.375L14.875 7.396C14.9723 7.49333 15.0417 7.594 15.083 7.698C15.125 7.802 15.146 7.90967 15.146 8.021C15.146 8.13233 15.125 8.24 15.083 8.344C15.0417 8.448 14.9723 8.54867 14.875 8.646L11.833 11.688C11.6663 11.8547 11.4687 11.938 11.24 11.938C11.0107 11.938 10.8057 11.8477 10.625 11.667ZM2.25 15.5C1.764 15.5 1.35067 15.33 1.01 14.99C0.67 14.6493 0.5 14.236 0.5 13.75V2.25C0.5 1.764 0.67 1.35067 1.01 1.01C1.35067 0.67 1.764 0.5 2.25 0.5H7.104C7.34 0.5 7.545 0.586667 7.719 0.76C7.89233 0.934 7.979 1.139 7.979 1.375C7.979 1.611 7.89233 1.816 7.719 1.99C7.545 2.16333 7.34 2.25 7.104 2.25H2.25V13.75H7.104C7.34 13.75 7.545 13.8367 7.719 14.01C7.89233 14.184 7.979 14.389 7.979 14.625C7.979 14.861 7.89233 15.066 7.719 15.24C7.545 15.4133 7.34 15.5 7.104 15.5H2.25Z" fill="#888" />
</svg> Çıkış</router-link>
                </li>

              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { get,getAges,getCategory } from "../service/tales";

export default {
  name: "Navbar",
    data() {
    return {
      q: {
      age: "",
      category: "",
      title: null,
      status: ""
    },
      ages: {},
      catAll: {},
      isHome: true,
      isArchive: false,
      searchID: {id:''},
      loaded: false
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    onlyNumber ($event) {
    let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
    }
    },
    getAges: function(){
    getAges().then((res) => {
        this.ages = res.data.data;
    })
    },
    getCategory(){
      getCategory().then((res) => {
        this.catAll = res.data.data;
      });
    },
    changePage(d) {
      this.isHome = d == 0 ? true:false ;
      this.isArchive = d == 1 ? true:false ;
    },
    goTale: function(tale){
      let self = this;
      if(tale.id !== '') {
          get(tale.id).then((res) => {
              this.searchID.id = '';
              window.location.replace("/tale/" + res.data.data.id);
          }).catch(function (error) {
              if (error.response) {
                self.searchID.id = '';
                self.$notify({
                  group: 'foo',
                  title: 'Hata',
                  text: "Lütfen masal IDsi giriniz."
                });
              }
          });
      } else {
          self.$notify({
            group: 'foo',
            title: 'Hata',
            text: "Lütfen masal IDsi giriniz."
          });
      }
    },
    goSearch: function(){
          this.$store.commit("searchUpdate", this.q)
            this.q = {
                age: "",
                category: "",
                title: null,
                status: ""
              }
          this.$router.push("/search");
          this.searchID.id = '';
    },
    loadAll() {
      if(!this.loaded) {
        this.getCategory();
        this.getAges();
      }
    }
  },
  mounted() {
    this.getCategory();
    this.getAges();
  },
};
</script>
<style scoped>
.bg-nav {
  background: #fff;
}
.bg-sub-bar {
 background: #1e2c40;
 color:#f1f8fe;
}
</style>
